import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.178 6.735a1 1 0 0 0-1.356-1.47L7.163 8.639 5.68 7.266a1 1 0 0 0-1.358 1.468l2.163 2a1 1 0 0 0 1.356.001zM16 7a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2zM16 15a1 1 0 1 0 0 2h11a1 1 0 1 0 0-2zM15 24a1 1 0 0 1 1-1h11a1 1 0 1 1 0 2H16a1 1 0 0 1-1-1M12.235 13.322a1 1 0 0 1-.057 1.413l-4.338 4a1 1 0 0 1-1.356 0l-2.163-2a1 1 0 0 1 1.358-1.47l1.484 1.374 3.66-3.374a1 1 0 0 1 1.412.057M12.178 22.735a1 1 0 1 0-1.356-1.47l-3.659 3.374-1.484-1.373a1 1 0 0 0-1.358 1.468l2.163 2a1 1 0 0 0 1.356.001z"
    />
  </svg>
);
const SvgIconListChecks = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconListChecks);
export default Memo;
